export default function paymentMethodBR(value) {
  switch (value) {
    case "MONEY":
      return "Dinheiro";
    case "CREDIT":
      return "Crédito";
    case "DEBIT":
      return "Débito";
    case "PIX":
      return "Pix";
    case "BANK_SLIP":
      return "A Prazo";
    default:
      return "Forma de pagamento não informada";
  }
}
